import React from "react";
import "./form.css";
import {
  FormControl,
  FormLabel,
  Input,
  NumberInputField,
  NumberInput,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Select,
} from "@chakra-ui/react";
import emailjs from "@emailjs/browser";
import { Button, Stack } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import { useRef } from "react";
const Form = () => {
  const [data, setData] = useState({
    name: "",
    surname: "",
    email: "",
    contact: "",
    company: "",
    noOfEmp: 0,
    vatPayer: "",
    invoicesIssued: 0,
    supplierInvoices: 0,
  });
  const form = useRef();

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      let s = await addDoc(collection(db, "contact"), data);
      if (s) {
        emailjs
          .sendForm(
            "service_qhjw83l",
            "template_bzpxjkb",
            form.current,
            "FE4Nm6vu9GwxzT44K"
          )
          .then(
            (result) => {
              console.log(result.text);
            },
            (error) => {
              console.log(error.text);
            }
          );
        setData({
          name: "",
          surname: "",
          email: "",
          contact: "",
          company: "",
          noOfEmp: 0,
          vatPayer: "",
          invoicesIssued: 0,
          supplierInvoices: 0,
        });
        alert("Form Submitted Successfully");
      }
    } catch (error) {
      alert(error.message);
    }
  };
  return (
    <div className="iconta__formular section_margin" id="form">
      <div className="iconta__formular-form">
        <div className="iconta__formular-form_title">
          <h1 id="top-form">Solicitați o ofertă</h1>
        </div>
        <div className="iconta__formular-form_text">
          <p>Consultanții noștrii vă vor contacta în cel mai scurt timp</p>
        </div>
      </div>

      <div className="form">
        <form ref={form} onSubmit={submitForm}>
          <div className="iconta__formular-container">
            <div className="iconta__formular-container_1">
              <div className="form-nume">
                <FormControl isRequired>
                  <FormLabel htmlFor="nume">Nume</FormLabel>
                  <Input
                    name="name"
                    value={data.name}
                    id="nume"
                    placeholder="Nume"
                    required
                    type="text"
                    onChange={(e) => setData({ ...data, name: e.target.value })}
                  />
                </FormControl>
              </div>

              <div className="form-prenume">
                <FormControl isRequired>
                  <FormLabel htmlFor="prenume">Prenume</FormLabel>
                  <Input
                    name="prenume"
                    value={data.surname}
                    id="prenume"
                    placeholder="Prenume"
                    required
                    type="text"
                    onChange={(e) =>
                      setData({ ...data, surname: e.target.value })
                    }
                  />
                </FormControl>
              </div>

              <div className="form-email">
                <FormControl isRequired>
                  <FormLabel htmlFor="email">E-mail</FormLabel>
                  <Input
                    name="email"
                    id="email"
                    placeholder="E-mail"
                    required
                    value={data.email}
                    type="email"
                    onChange={(e) =>
                      setData({ ...data, email: e.target.value })
                    }
                  />
                </FormControl>
              </div>
            </div>

            <div className="iconta__formular-container_2">
              <div className="form-telefon">
                <FormControl isRequired>
                  <FormLabel htmlFor="telefon">Telefon</FormLabel>
                  <Input
                    name="telefon"
                    id="telefon"
                    value={data.contact}
                    placeholder="Telefon"
                    required
                    type="number"
                    onChange={(e) =>
                      setData({ ...data, contact: e.target.value })
                    }
                  />
                </FormControl>
              </div>

              <div className="form-numeleFirmei">
                <FormControl isRequired>
                  <FormLabel htmlFor="numeleFirmei">Numele firmei</FormLabel>
                  <Input
                    name="numeleFirmei"
                    id="numeleFirmei"
                    value={data.company}
                    placeholder="Numele firmei"
                    required
                    type="text"
                    onChange={(e) =>
                      setData({ ...data, company: e.target.value })
                    }
                  />
                </FormControl>
              </div>

              <div className="form-numarAngajati">
                <FormControl isRequired>
                  <FormLabel htmlFor="numarAngajati">Număr angajați</FormLabel>
                  <NumberInput
                    max={50}
                    value={data.noOfEmp}
                    min={1}
                    required
                    name="numarAngajati"
                    onChange={(e) => setData({ ...data, noOfEmp: e })}
                  >
                    <NumberInputField name="numarAngajati" id="numarAngajati" />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
              </div>
            </div>

            <div className="iconta__formular-container_3">
              <div className="form-platitorTva">
                <FormControl isRequired>
                  <FormLabel htmlFor="platitorTva">Plătitor de TVA?</FormLabel>
                  <Select
                  value={data.vatPayer}
                    name="platitorTva"
                    id="platitorTva"
                    placeholder="Selecteaza"
                    required
                    type="text"
                    onChange={(e) =>
                      setData({ ...data, vatPayer: e.target.value })
                    }
                  >
                    <option value="DA">DA</option>
                    <option value="NU">NU</option>
                  </Select>
                </FormControl>
              </div>

              <div className="form-facturiEmise">
                <FormControl isRequired>
                  <FormLabel htmlFor="facturiEmise">Facturi emise</FormLabel>
                  <NumberInput
                    max={1000}
                    min={1}
                    required
                    value={data.invoicesIssued}
                    name="facturiEmise"
                    onChange={(e) => setData({ ...data, invoicesIssued: e })}
                  >
                    <NumberInputField name="facturiEmise" id="facturiEmise" />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
              </div>

              <div className="form-facturiFurnizori">
                <FormControl isRequired>
                  <FormLabel htmlFor="facturiFurnizori">
                    Facturi furnizori
                  </FormLabel>
                  <NumberInput
                    max={1000}
                    value={data.supplierInvoices}
                    name="facturiFurnizori"
                    min={1}
                    isRequired
                    onChange={(e) => setData({ ...data, supplierInvoices: e })}
                  >
                    <NumberInputField
                      name="facturiFurnizori"
                      id="facturiFurnizori"
                    />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
              </div>
            </div>
          </div>

          <div className="iconta__formular-informare">
            <p>* Toate căsuțele marcate cu asterisc (*) sunt obligatorii</p>
          </div>

          <div className="iconta__formular-button">
            <Stack direction="row" spacing={4}>
              <Button
                rightIcon={<ArrowForwardIcon />}
                colorScheme="teal"
                variant="outline"
                type="submit"
              >
                Trimite
              </Button>
            </Stack>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form;
